// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"87":"jobs","353":"contact","594":"about","927":"synthesis","946":"news","962":"home","983":"products"}[chunkId] + "." + {"87":"71ad8956","353":"4f3f6d89","594":"3e0b177a","927":"d3591ff4","946":"8b56f469","962":"86a18bea","983":"367b76f1"}[chunkId] + ".css";
};